import { useCloseOnEscape } from "hooks/useCloseOnEscape";
import { useTranslation } from "react-i18next";
import type { TimeReportsGroupByOption } from "../toolbar/timeReportsToolbar.component";
import {
  CloseButton,
  HeaderRow,
  HiddenRadio,
  Overlay,
  Panel,
  RadioControl,
  RadioGroup,
  RadioLabel,
  RadioOption,
  Section,
  SectionDescription,
  SectionTitle,
  Title,
} from "./timeReportsOptionsPanel.styled";

interface TimeReportsOptionsPanelProps {
  isOpen: boolean;
  groupByOption: TimeReportsGroupByOption;
  onGroupByChange: (value: TimeReportsGroupByOption) => void;
  onClose: () => void;
}

export const TimeReportsOptionsPanel = (
  props: TimeReportsOptionsPanelProps,
): JSX.Element | null => {
  const { t } = useTranslation();
  const isOpen = props.isOpen;
  const onClose = props.onClose;

  useCloseOnEscape({
    isOpen,
    onClose,
    stopPropagation: true,
  });

  if (!isOpen) return null;

  return (
    <Overlay onClick={onClose}>
      <Panel onClick={(event) => event.stopPropagation()}>
        <HeaderRow>
          <Title>{t("TimeReports.Options")}</Title>
          <CloseButton
            iconName="v2/cross"
            size="small"
            aria-label={t("DesignComponents.CloseModal")}
            onClick={onClose}
          />
        </HeaderRow>

        <Section>
          <SectionTitle>{t("TimeReports.GroupBy")}</SectionTitle>
          <SectionDescription>
            {t("TimeReports.GroupByDescription")}
          </SectionDescription>
          <RadioGroup role="radiogroup" aria-label={t("TimeReports.GroupBy")}>
            <RadioOption>
              <HiddenRadio
                type="radio"
                name="time-reports-group-by"
                checked={props.groupByOption === "team"}
                onChange={() => props.onGroupByChange("team")}
              />
              <RadioControl />
              <RadioLabel>{t("TimeReports.Team")}</RadioLabel>
            </RadioOption>
            <RadioOption>
              <HiddenRadio
                type="radio"
                name="time-reports-group-by"
                checked={props.groupByOption === "person"}
                onChange={() => props.onGroupByChange("person")}
              />
              <RadioControl />
              <RadioLabel>{t("TimeReports.Person")}</RadioLabel>
            </RadioOption>
          </RadioGroup>
        </Section>
      </Panel>
    </Overlay>
  );
};
